module.exports = __webpack_public_path__ + "01_medium_gold.baf930d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_medium_gold.png
// module id = tzHp
// module chunks = 0